import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home'; 
import './App.css';
import './assets/css/style.css'; 
import './assets/css/common.css'; 
import About from './pages/About';
import Topbar from './component/Topbar';
import Sidebar from './component/Sidebar';
import VendorAuth from './pages/VendorAuth';
import AddHostelOwner from './pages/AddHostelOwner';
import AllOwner from './pages/AllOwner';
import Coupon from './pages/Coupon';
import ProductAvailability from './pages/ProductAvailability';
import DeliveryCost from './pages/DeliveryCost';
import VendorApproved from './pages/VendorApproved';
import ManageSku from './pages/ManageSku';
import VendorReport from './pages/VendorReport';
import TotalOrder from './pages/TotalOrder';
import CancelledOrder from './pages/Orders/CancelledOrder';
import PendingOrder from './pages/Orders/PendingOrder';
import ManageCategory from './pages/ManageCategory';
import CategoryBuilder from './component/CategoryBuilder';
import PackageManagement from './pages/PackageManagement';
import SetPassword from './pages/SetPassword';
import VendorLogin from './pages/Login';
import CreateProduct from './pages/product/CreateProduct';
import ProductGallery from './pages/product/ProductGallery';
import AllProduct from './pages/product/AllProduct';
import EditProduct from './pages/product/EditProduct';
import ProductVarient from './pages/product/ProductVarient';
import ProductAttribute from './pages/product/ProductAttribute';
import ProductDelivery from './pages/product/ProductDelivery';
import AllOrder from './pages/Orders/AllOrder';
import ShippedOrder from './pages/Orders/ShippedOrder';
import DeliveredOrder from './pages/Orders/DeliveredOrder';
import OrderView from './pages/Orders/OrderView';
import StockReport from './pages/Report/StockReport';
import OrderReport from './pages/Orders/OrderReport';
import ProductSales from './pages/Report/ProductSales';
import CategorySales from './pages/Report/CategorySales';
import ProductPerformance from './pages/Report/ProductPerformance';
import SalesTrend from './pages/Report/SalesTrend';
import RevenueGrowth from './pages/Report/RevenueGrowth';
import Invoice from './pages/Orders/Invoice';
import PaymentSummary from './pages/payment/PaymentSummary';
import AddSupportTicket from './pages/Support/AddSupportTicket';
import AllSupportTicket from './pages/Support/AllSupportTicket';
import ChargesByCategory from './pages/payment/ChargesByCategory';
import Profile from './pages/Profile';


function App() {
  return (
    <Router>
      
  


      <Routes>
        <Route path="/register" element={<VendorAuth />} />   
        <Route path="/vendor/set-password" element={<SetPassword />} />  
        <Route path="/" element={<VendorLogin />} />  
        <Route path="/product-create" element={<CreateProduct />} />  
        <Route path="/product/gallery/:uuid" element={<ProductGallery />} />  
        <Route path="/product-list" element={<AllProduct />} />  
        <Route path="/product/basic-details/:uuid" element={<EditProduct />} />  
        <Route path="/product/variant/:uuid" element={<ProductVarient />} />  
        <Route path="/product/attribute/:uuid" element={<ProductAttribute />} />  
        <Route path="/product/delivery/:uuid" element={<ProductDelivery />} />  
        <Route path="/all-orders" element={<AllOrder />} />  
        <Route path="/pending-orders" element={<PendingOrder />} />  
        <Route path="/shipped-orders" element={<ShippedOrder />} />  
        <Route path="/delivered-orders" element={<DeliveredOrder />} />  
        <Route path="/cancelled-orders" element={<CancelledOrder />} />  
     
 
 

        <Route path="/dashboard" element={<Home />} />   
        <Route path="/create-hostel-owner" element={<AddHostelOwner />} />   
        <Route path="/all-owner" element={<AllOwner />} />   
        <Route path="/about" element={<About />} />   
        <Route path="/coupon" element={<Coupon />} />   
        <Route path="/product-availability" element={<ProductAvailability />} />   
        <Route path="/delivery-cost" element={<DeliveryCost />} />   
        <Route path="/approve-vendor" element={<VendorApproved />} />   
        <Route path="/sku-assured" element={<ManageSku />} />   
        <Route path="/vendor-reports" element={<VendorReport />} />   
        <Route path="/user-orders" element={<TotalOrder />} />   
        <Route path="/user-cancelled" element={<CancelledOrder />} />   
        <Route path="/pending-carts" element={<PendingOrder />} />   
        <Route path="/category-manage" element={<ManageCategory />} />   
        <Route path="/category-builder" element={<CategoryBuilder />} />   
        <Route path="/package" element={<PackageManagement />} />   
        <Route path="/vendor/order-details/:order_uuid" element={<OrderView />} />   
        <Route path="/report-stock" element={<StockReport />} />   
        <Route path="/order-reports" element={<OrderReport />} />   
        <Route path="/report-product-sales" element={<ProductSales />} />   
        <Route path="/report-category-sales" element={<CategorySales />} />   
        <Route path="/report-product-performance" element={<ProductPerformance />} />   
        <Route path="/report-sales-trends" element={<SalesTrend />} />   
        <Route path="/report-growth" element={<RevenueGrowth />} />   
        <Route path="/vendor/invoice/:order_uuid" element={<Invoice />} />



        <Route path="/report-payment-summary" element={<PaymentSummary />} />   
        <Route path="/report-support-tickets" element={<AddSupportTicket />} />   
        <Route path="/support/tickets" element={<AllSupportTicket />} />   
        <Route path="/platform-charge" element={<ChargesByCategory />} />   
        <Route path="/profile" element={<Profile />} />   
  

   



      </Routes>
  
    </Router>
  );
}

export default App;
